import React, { Fragment } from "react";
import { RadioButtonWithLabel } from "../../../../components";
import { Heading } from "@telia/teddy";
import _get from "lodash/get";
import { MBB_NUMBER_LEN } from "../../../../../../constants";
import { Account } from "../../../../../../models/state";
import { PhoneNumberFormatters } from "../../../../app/utils";
import TEXT from "../../../text-consts";
import SusbscriptionCard from "../../atoms/SubscriptionCard/SubscriptionCard";
import "./RelatedAccounts.less";

interface RelatedAccountsProps {
    relatedAccounts: Account[];
    selectedAccountId: string;
    setSelectedAccountId: (accountID: string | null) => void;
}

const RelatedAccounts: React.FC<RelatedAccountsProps> = ({
    relatedAccounts,
    selectedAccountId,
    setSelectedAccountId,
}) => {
    const formatterPhone = PhoneNumberFormatters[0].displayFn;
    const formatterMBB = PhoneNumberFormatters[3].displayFn;
    return (
        <Fragment>
            <Heading mb="100" as="h2" variant="title-100">
                {TEXT.SUMMARY.RELATED_ACCOUNTS.WHICH_INVOICE}
            </Heading>
            {relatedAccounts.map((account) => {
                return (
                    <div className="related-accounts" key={`account-${account.accountId}`}>
                        <RadioButtonWithLabel
                            value={account.accountId}
                            onChange={(event) => setSelectedAccountId(event.target.value)}
                            name={`related-account`}
                            checked={account.accountId === selectedAccountId}
                            hasRichContent
                        >
                            <div className="related-accounts__customer-number" data-di-mask>
                                {TEXT.SUMMARY.RELATED_ACCOUNTS.CUSTOMER_NUMBER} <span>{account.accountId}</span>
                            </div>
                            <div className="related-accounts__subscriptions">
                                {_get(account, "subscriptions", []).map((sub) => (
                                    <SusbscriptionCard
                                        key={sub.phone}
                                        name={sub.firstName}
                                        phone={
                                            sub.phone.length === MBB_NUMBER_LEN
                                                ? formatterMBB(sub.phone)
                                                : formatterPhone(sub.phone)
                                        }
                                    />
                                ))}
                            </div>
                        </RadioButtonWithLabel>
                    </div>
                );
            })}
            <RadioButtonWithLabel
                value=""
                onChange={() => setSelectedAccountId(null)}
                name={`related-account`}
                checked={!selectedAccountId}
                hasRichContent
            >
                <span className="related-accounts__create-new">{TEXT.SUMMARY.RELATED_ACCOUNTS.CREATE_NEW}</span>
            </RadioButtonWithLabel>
        </Fragment>
    );
};

export default RelatedAccounts;
